import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { RevenueShareLedger } from '../models/revenueShare.model';
import { getRevenueShareLedger } from '../requests/revenueShareLedger.request.ts';

export function useRevenueShareLedger(partnerId: string) {
  const [revenueShareLedger, setRevenueShareLedger] = useState<RevenueShareLedger>(
    new RevenueShareLedger()
  );

  const { request: fetchRevenueShareLedger, status } = useRequest(
    async () => {
      if (!partnerId) {
        return;
      }
      setRevenueShareLedger(await getRevenueShareLedger(partnerId));
    },
    { requestOnMount: true }
  );

  return {
    revenueShareLedger,
    fetchRevenueShareLedger,
    isSettled: status.isError || status.isSuccess,
  };
}
